import { FormValues, ValidationErrors } from './types';

export const AgeRestrictionsValidator = (values: FormValues): ValidationErrors => {
  const errors: ValidationErrors = {
    restrictions: {}
  };
  const { restrictions } = values;

  if (values.global && Number(values.global < 1)) {
    errors.global = 'app.validation.value-less';
  }

  if (values.global && Number(values.global > 99)) {
    errors.global = 'app.validation.value-more';
  }

  values.selectedCountries.forEach((country) => {
    if (restrictions) {
      if (restrictions[country] && Number(restrictions[country]) < 1) {
        errors.restrictions[country] = 'app.validation.value-less';
      }

      if (restrictions[country] && Number(restrictions[country]) > 99) {
        errors.restrictions[country] = 'app.validation.value-more';
      }
    }
  });

  return errors;
};
